export default {
  common: {
    save: "ਸੇਵ ਕਰੋ",
    cancel: "ਰੱਦ ਕਰੋ",
    back: "ਪਿੱਛੇ",
    submit: "ਜਮ੍ਹਾਂ ਕਰੋ",
    loading: "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ…",
    yes: "ਹਾਂ",
    no: "ਨਹੀਂ",
    confirm: "ਪੁਸ਼ਟੀ ਕਰੋ",
    close: "ਬੰਦ ਕਰੋ",
    search: "ਖੋਜੋ",
    all: "ਸਾਰੇ",
    done: "ਹੋ ਗਿਆ",
    logout: "ਲਾਗ ਆਉਟ",
    language: "ਭਾਸ਼ਾ",
    selectLanguage: "ਆਪਣੀ ਭਾਸ਼ਾ ਚੁਣੋ",
    saving: "ਸੇਵ ਹੋ ਰਿਹਾ ਹੈ…",
    saved: "ਸੇਵ ਹੋ ਗਿਆ",
    viewAll: "ਸਾਰੇ ਵੇਖੋ",
    filters: "ਫਿਲਟਰ",
  },
  nav: {
    home: "ਹੋਮ",
    installs: "ਇੰਸਟਾਲੇਸ਼ਨ",
    requests: "ਬੇਨਤੀਆਂ",
    orders: "ਆਰਡਰ",
    profile: "ਪ੍ਰੋਫਾਈਲ",
    leads: "ਲੀਡਸ",
    service: "ਸੇਵਾ",
    payouts: "ਭੁਗਤਾਨ",
    toolkit: "ਟੂਲਕਿੱਟ",
  },
  profile: {
    yourAccount: "ਤੁਹਾਡਾ ਖਾਤਾ",
    title: "ਪ੍ਰੋਫਾਈਲ.",
    city: "ਸ਼ਹਿਰ",
    state: "ਰਾਜ",
    pinCode: "ਪਿੰਨ ਕੋਡ",
    pinCodeHelp: "ਤੁਹਾਡਾ ਖੇਤਰ ਉਹ ਆਗਿਆ ਪ੍ਰਾਪਤ ਖੇਤਰ ਹੈ ਜਿਸ ਵਿੱਚ ਇਹ ਪਿੰਨ ਕੋਡ ਆਉਂਦਾ ਹੈ।",
    upiId: "UPI ਆਈਡੀ (ਭੁਗਤਾਨਾਂ ਲਈ)",
    saveProfile: "ਪ੍ਰੋਫਾਈਲ ਸੇਵ ਕਰੋ",
    preferredLanguage: "ਪਸੰਦੀਦਾ ਭਾਸ਼ਾ",
    logoutConfirm: "ਕੀ ਤੁਸੀਂ ਸੱਚਮੁੱਚ ਲਾਗ ਆਉਟ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
    linkedAddresses: "ਜੁੜੇ ਪਤੇ",
    noAddresses: "ਅਜੇ ਤੱਕ ਕੋਈ ਪਤਾ ਸੇਵ ਨਹੀਂ ਕੀਤਾ ਗਿਆ।",
    referFriend: "ਦੋਸਤ ਨੂੰ ਰੈਫਰ ਕਰੋ",
    referFriendSub: "ਆਪਣਾ ਕੋਡ ਸਾਂਝਾ ਕਰੋ — ਜਦੋਂ ਉਹ ਸੋਲਰ ਲਗਵਾਉਣ ਤਾਂ ਤੁਹਾਨੂੰ ਇਨਾਮ ਮਿਲੇਗਾ।",
    myReferrals: "ਮੇਰੇ ਰੈਫਰਲ",
    shareFriend: "ਦੋਸਤ ਨਾਲ ਸਾਂਝਾ ਕਰੋ",
    secureNote: "ਤੁਹਾਡਾ ਡਾਟਾ ਸੁਰੱਖਿਅਤ ਫੋਨ OTP ਰਾਹੀਂ ਪ੍ਰਮਾਣਿਤ ਹੈ — ਪਾਸਵਰਡ ਯਾਦ ਰੱਖਣ ਜਾਂ ਗੁਆਉਣ ਦੀ ਲੋੜ ਨਹੀਂ।",
    toolkit: "ਟੂਲਕਿੱਟ",
    incentiveSchemes: "ਇੰਸੈਂਟਿਵ ਸਕੀਮਾਂ",
  },
  tickets: {
    myRequests: "ਮੇਰੀਆਂ ਬੇਨਤੀਆਂ",
    raiseComplaint: "ਸ਼ਿਕਾਇਤ ਦਰਜ ਕਰੋ",
    cancelRequest: "ਬੇਨਤੀ ਰੱਦ ਕਰੋ",
    cancelConfirmTitle: "ਕੀ ਇਸ ਬੇਨਤੀ ਨੂੰ ਰੱਦ ਕਰਨਾ ਹੈ?",
    cancelConfirmBody: "ਅਸੀਂ ਇਸ ਸੇਵਾ ਬੇਨਤੀ 'ਤੇ ਕੰਮ ਰੋਕ ਦੇਵਾਂਗੇ। ਤੁਸੀਂ ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਨਵੀਂ ਬੇਨਤੀ ਕਰ ਸਕਦੇ ਹੋ।",
    cancelledToast: "ਬੇਨਤੀ ਰੱਦ ਕੀਤੀ ਗਈ",
    keepRequest: "ਨਹੀਂ, ਰਹਿਣ ਦਿਓ",
    noRequests: "ਅਜੇ ਤੱਕ ਕੋਈ ਸੇਵਾ ਬੇਨਤੀ ਨਹੀਂ।",
    statusOpen: "ਖੁੱਲ੍ਹਾ",
    statusInProgress: "ਜਾਰੀ ਹੈ",
    statusOnHold: "ਰੋਕਿਆ ਗਿਆ",
    statusActionNeeded: "ਕਾਰਵਾਈ ਲੋੜੀਂਦੀ",
    statusCompleted: "ਪੂਰਾ ਹੋਇਆ",
    statusClosed: "ਬੰਦ",
    statusCancelled: "ਰੱਦ",
    statusDropped: "ਛੱਡਿਆ ਗਿਆ",
    filterAll: "ਸਾਰੇ",
    filterActive: "ਸਰਗਰਮ",
    filterResolved: "ਹੱਲ ਕੀਤਾ",
    nonServiceable: "ਗੈਰ-ਸੇਵਾਯੋਗ ਖੇਤਰ",
    raisedOn: "ਦਰਜ ਕੀਤਾ",
    ticketNumber: "ਟਿਕਟ",
    wipInstall: "ਇੰਸਟਾਲੇਸ਼ਨ ਜਾਰੀ",
    raisedByYou: "ਤੁਸੀਂ ਦਰਜ ਕੀਤਾ",
    raisedByTeam: "ਸਾਡੀ ਟੀਮ ਨੇ ਦਰਜ ਕੀਤਾ",
    timeline: "ਟਾਈਮਲਾਈਨ",
    pending: "ਬਕਾਇਆ",
    resolutionSummary: "ਹੱਲ ਸਾਰ",
    youRatedPrefix: "ਤੁਸੀਂ ਇਸਨੂੰ ਰੇਟ ਕੀਤਾ",
    howWasResolution: "ਹੱਲ ਕਿਵੇਂ ਰਿਹਾ?",
    submitFeedback: "ਫੀਡਬੈਕ ਜਮ੍ਹਾਂ ਕਰੋ",
  },
  home: {
    greeting: "ਸਤ ਸ੍ਰੀ ਅਕਾਲ",
    newInstallation: "ਨਵੀਂ ਇੰਸਟਾਲੇਸ਼ਨ",
    raiseComplaint: "ਸ਼ਿਕਾਇਤ ਦਰਜ ਕਰੋ",
    welcomeBack: "ਮੁੜ ਸੁਆਗਤ ਹੈ",
    customerSubtitle: "ਪੂਰਵੋਦਯ ਨਾਲ ਤੁਹਾਡੀ ਸੋਲਰ ਯਾਤਰਾ, ਸਭ ਇੱਕ ਥਾਂ 'ਤੇ।",
  },
  sc: {
    requestsTitle: "ਸੇਵਾ ਬੇਨਤੀਆਂ",
    requestsForCustomers: "ਤੁਹਾਡੇ ਗਾਹਕਾਂ ਲਈ",
    kpiOpen: "ਖੁੱਲ੍ਹਾ",
    kpiResolved: "ਹੱਲ ਹੋਇਆ",
    kpiInProblem: "ਸਮੱਸਿਆ ਵਿੱਚ",
    raiseRequest: "ਸੇਵਾ ਬੇਨਤੀ ਦਰਜ ਕਰੋ",
    slaBreached: "SLA ਉਲੰਘਣਾ",
    viewPhotos: "ਫੋਟੋਆਂ ਵੇਖੋ",
    hidePhotos: "ਫੋਟੋਆਂ ਲੁਕਾਓ",
    noRequestsWindow: "ਇਸ ਮਿਆਦ ਵਿੱਚ ਕੋਈ ਸੇਵਾ ਬੇਨਤੀ ਨਹੀਂ।",
  },
};
